var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 51,
    viewBox: "0 0 43 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.75C4.30964 9.75 3.75 10.3096 3.75 11V46C3.75 46.6904 4.30964 47.25 5 47.25H38C38.6904 47.25 39.25 46.6904 39.25 46V23.6688C39.25 22.7023 40.0335 21.9188 41 21.9188C41.9665 21.9188 42.75 22.7023 42.75 23.6688V46C42.75 48.6234 40.6234 50.75 38 50.75H5C2.37665 50.75 0.25 48.6234 0.25 46V11C0.25 8.37665 2.37664 6.25 5 6.25H13.4545V9.75H5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5415 3.5V9.67483H26.5975V3.5H13.5415ZM10.5415 2.57343C10.5415 1.42831 11.4698 0.5 12.615 0.5H27.5241C28.6692 0.5 29.5975 1.4283 29.5975 2.57343V10.6014C29.5975 11.7465 28.6692 12.6748 27.5241 12.6748H12.615C11.4698 12.6748 10.5415 11.7465 10.5415 10.6014V2.57343Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6713 15.1535C39.4052 15.7823 39.4905 16.887 38.8617 17.621L20.7834 38.7228L9.91698 29.4133C9.183 28.7845 9.09775 27.6797 9.72656 26.9458C10.3554 26.2118 11.4601 26.1265 12.1941 26.7554L20.4026 33.7877L36.2037 15.3439C36.8325 14.6099 37.9373 14.5247 38.6713 15.1535Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8324 10.0576H27.5247V6.55764H33.8324C34.7989 6.55764 35.5824 7.34114 35.5824 8.30764C35.5824 9.27414 34.7989 10.0576 33.8324 10.0576Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.3b4921c527669ac418b695e46dd6c97b.svg";
export { ForwardRef as ReactComponent };